
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(1944|3251)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
